import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 14\" id=\"arrow-left\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"nonzero\" d=\"M0 7.4V7v-.4l.2-.2.1-.1 6-6a1 1 0 011.4 0c.4.4.4 1 0 1.4L3.4 6H17c.5 0 1 .4 1 1 0 .5-.5 1-1 1H3.4l4.3 4.3A1 1 0 017 14a1 1 0 01-.7-.3l-6-6-.2-.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol